export const nonEmpty = (message) => (value) => (!value ? message : undefined);

export const expectValue = (expected, message) => (value) =>
  value !== expected ? message : undefined;
